/**
 * Created by jerome on 09/10/2018.
 */


function SVGCoord (x, y) {
  if (isNaN(x) || isNaN(y)) {
    throw new Error(`NaN encountered: ${x}/${y}`)
  }
  this.x = x
  this.y = y
  this.sx = x
  this.sy = y
}

export default SVGCoord
